import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import classnames from 'classnames';
import * as utils from '../../utils/socialHelper';
import {
  trackSocialMedia,
  addLead,
  setSoftLeadEvent
} from '../../store/actions/dataLayer';
import { getBoatUrl } from '../../utils/urlHelpers/boat';
import { getEngineUrl } from '../../utils/urlHelpers/engine';
import messages from '../../utils/translationMessages';
import { PortalConfigContext } from '../../config/portal';
import { listingPropTypes } from '../../utils/commonPropTypes';
import './styles.css';
import closeButton from '../../icons/modal-close-button.svg';
import Email from '../../icons/EmailRound.svg';
import Facebook from '../../icons/FacebookRound.svg';
import Pinterest from '../../icons/PinterestRound.svg';
import Print from '../../icons/PrintRound.svg';
import Twitter from '../../icons/TwitterRound.svg';
import Whatsapp from '../../icons/WhatsappRound.svg';
import get from 'lodash/get';
import Link from '../SEO/Link';
import { SocialShare as SocialShareComponent } from '@dmm/lib-react-ui-components';
import { isBoatDetailsPageRedesign } from '../../utils/newBDPHelper';

class SocialShare extends PureComponent {
  state = {
    open: this.props.open,
    copied: false
  };
  containerRef = React.createRef();

  handleShareToggle = () => {
    const open = !this.state.open;

    this.setState({
      open: open
    });

    this.props.handleShareToggle(open);
  };

  handleSocialShare = (socialName) => {
    const { listing, productType } = this.props;
    const { id } = listing;
    const title = utils.getSocialTitle(listing, this.context.fullName);
    const url =
      productType === 'boat'
        ? getBoatUrl(listing, true)
        : getEngineUrl(listing, true);
    utils.openSocialModal(socialName, url, title, listing);
    this.props.addLead(id, `${socialName} share`);
    this.props.trackSocialMedia(socialName, 'social share', url);
  };

  handleShare = (type) => {
    const { listing, productType } = this.props;
    const { id } = listing;
    const title = utils.getSocialTitle(listing, this.context.fullName);
    const url =
      productType === 'boat'
        ? getBoatUrl(listing, true)
        : getEngineUrl(listing, true);
    if (type === 'print') {
      utils.print();
    }
    if (type === 'email') {
      utils.email(url, title);
    }
    this.props.addLead(id, `${type} listing`);
    this.props.trackSocialMedia(type, `${type} listing`, url);
  };

  handleCopyLink = () => {
    const { listing } = this.props;

    window.navigator.clipboard.writeText(getBoatUrl(listing, true));

    this.setState({ copied: true });
  };

  handleTourClick = () => {
    setSoftLeadEvent('immersive tour');
    this.handleShareToggle();
    this.props.openImmersiveTourModal();
  };

  handleOpenContactForm = () => {
    this.handleShareToggle();

    this.props.handleOpenContactForm();
  };

  getContactLinks = () => {
    const { listing, intl } = this.props;
    const { formatMessage: t } = intl;

    const hasImmersiveTour = !!get(listing, 'virtualTour', false);

    const contactLinks = [
      {
        text: t(messages.socialShare.contact),
        onClick: this.handleOpenContactForm.bind(this)
      }
    ];

    if (hasImmersiveTour) {
      contactLinks.push({
        text: t(messages.socialShare.immersiveTour),
        onClick: this.handleTourClick.bind(this)
      });
    }

    return contactLinks;
  };

  render() {
    const {
      intl: { formatMessage: t },
      type,
      listing,
      breakpoint
    } = this.props;
    const hasImmersiveTour = get(listing, 'virtualTour.url', false);
    const { open, copied } = this.state;
    return (
      <div
        ref={this.containerRef}
        className={classnames('social-share', {
          [`social-share-${type}`]: type
        })}
      >
        {!isBoatDetailsPageRedesign(this.context) && (
          <button
            className="social-share-trigger"
            onClick={this.handleShareToggle}
          >
            {breakpoint !== 'mobile' && t(messages.socialShare.share)}
          </button>
        )}
        {!isBoatDetailsPageRedesign(this.context) && open && (
          <div className="social-dropdown">
            <div className="social-dropdown-modal">
              <div className="social-dropdown-modal-title">
                <h3>{t(messages.socialShare.shareBoat)}</h3>
                <button
                  className="close-modal"
                  onClick={this.handleShareToggle}
                >
                  <img src={closeButton} />
                </button>
              </div>
              <div className="social-dropdown-modal-scroller">
                <div className="social-dropdown-modal-scroller-frame">
                  <ul>
                    <li>
                      <button
                        className="social-share-button facebook-share-button"
                        onClick={this.handleSocialShare.bind(this, 'facebook')}
                      >
                        <img src={Facebook} />
                        <p>{t(messages.socialShare.facebook)}</p>
                      </button>
                    </li>
                    <li>
                      <button
                        className="social-share-button twitter-share-button"
                        onClick={this.handleSocialShare.bind(this, 'twitter')}
                      >
                        <img src={Twitter} />
                        <p>{t(messages.socialShare.twitter)}</p>
                      </button>
                    </li>
                    <li>
                      <button
                        className="social-share-button pinterest-share-button"
                        onClick={this.handleSocialShare.bind(this, 'pinterest')}
                      >
                        <img src={Pinterest} />
                        <p>{t(messages.socialShare.pinterest)}</p>
                      </button>
                    </li>
                    <li>
                      <button
                        className="social-share-button whatsapp-share-button"
                        onClick={this.handleSocialShare.bind(this, 'whatsapp')}
                      >
                        <img src={Whatsapp} />
                        <p>{t(messages.socialShare.whatsapp)}</p>
                      </button>
                    </li>
                    <li>
                      <button
                        className="social-share-button email-share-button"
                        onClick={this.handleShare.bind(this, 'email')}
                      >
                        <img src={Email} />
                        <p>{t(messages.socialShare.email)}</p>
                      </button>
                    </li>
                    <li>
                      <button
                        className="social-share-button print-share-button"
                        onClick={this.handleShare.bind(this, 'print')}
                      >
                        <img src={Print} />
                        <p>{t(messages.socialShare.print)}</p>
                      </button>
                    </li>
                    <li>
                      <button
                        className="social-share-button social-share-more more-share-button"
                        onClick={this.handleShare.bind(this, 'more')}
                      >
                        <div>
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        <p>{t(messages.socialShare.more)}</p>
                      </button>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="social-dropdown-modal-link">
                <p>{getBoatUrl(listing, true)}</p>
                <button
                  className="copyLink"
                  onClick={this.handleCopyLink.bind(this)}
                >
                  {copied
                    ? t(messages.socialShare.copied)
                    : t(messages.socialShare.copyLink)}
                </button>
              </div>
              <div className="social-dropdown-modal-anchors">
                <a onClick={this.handleOpenContactForm.bind(this)}>
                  {t(messages.socialShare.contact)}
                </a>

                {hasImmersiveTour && (
                  <Link
                    className="hasImmersiveTour-button"
                    onClick={this.handleTourClick.bind(this)}
                  >
                    {t(messages.socialShare.immersiveTour)}
                  </Link>
                )}

                <span></span>
              </div>
            </div>
            <div
              className="social-share-background"
              onClick={this.handleShareToggle}
            ></div>
          </div>
        )}
        {isBoatDetailsPageRedesign(this.context) && this.props.openShareModal && (
          <SocialShareComponent
            title={t(messages.socialShare.shareBoat)}
            buttons={[
              {
                icon: 'facebook',
                text: 'Facebook',
                onClick: this.handleSocialShare.bind(this, 'facebook')
              },
              {
                icon: 'twitter',
                text: 'Twitter',
                onClick: this.handleSocialShare.bind(this, 'twitter')
              },
              {
                icon: 'pinterest',
                text: 'Pinterest',
                onClick: this.handleSocialShare.bind(this, 'pinterest')
              },
              {
                icon: 'whatsapp',
                text: 'Whatsapp',
                onClick: this.handleSocialShare.bind(this, 'whatsapp')
              },
              {
                icon: 'email',
                text: 'Email',
                onClick: this.handleShare.bind(this, 'email')
              },
              {
                icon: 'print',
                text: t(messages.socialShare.print),
                onClick: this.handleShare.bind(this, 'print')
              }
            ]}
            contact={this.getContactLinks()}
            input={{
              buttonText: copied
                ? t(messages.socialShare.copied)
                : t(messages.socialShare.copyLink),
              value: getBoatUrl(listing, true),
              onClick: this.handleCopyLink.bind(this)
            }}
            modal={{
              onClose: this.props.handleShareButton.bind(this)
            }}
          />
        )}
      </div>
    );
  }
}

SocialShare.propTypes = {
  /** Tracking */
  addLead: PropTypes.func,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired
  }).isRequired,
  /** Listing information of the boat */
  listing: listingPropTypes,
  productType: PropTypes.string,
  /** Tracking */
  trackSocialMedia: PropTypes.func,
  /** css variant  overlay|tray */
  type: PropTypes.oneOf(['overlay', 'tray']),
  open: PropTypes.bool,
  handleShareToggle: PropTypes.func,
  openImmersiveTourModal: PropTypes.func,
  handleOpenContactForm: PropTypes.func,
  breakpoint: PropTypes.string,
  openShareModal: PropTypes.bool,
  handleShareButton: PropTypes.func
};

SocialShare.contextType = PortalConfigContext;

export default connect(null, (dispatch) =>
    bindActionCreators(
      {
        addLead,
        trackSocialMedia
      },
      dispatch
    )
  )(injectIntl(SocialShare));
